import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const MultiplyIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M16.9497 7.05023L7.05021 16.9497" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M7.05029 7.05023L16.9498 16.9497" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export default MultiplyIcon;